import { reduceObjIndexed } from '@sleepstation/utils'
import { curry } from 'ramda'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

// eslint-disable-next-line import/prefer-default-export
export const findKey = curry((predicate, o) =>
  reduceObjIndexed(
    (acc, [key, value]) => (predicate(key, value) ? key : acc),
    undefined
  )(o)
)
